import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subscription } from 'rxjs';
import { DesksTurnsService } from 'src/app/services/turns-services/desks-turns-service/desks-turns.service';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { Breadcrumb } from 'src/app/models/breadcrumb-models/breadcrumb-model/breadcrumb.model';
import { HeaderBreadcrumbService } from 'src/app/components/header-components/header-breadcrumb/header-breadcrumb.service';
import { BRoute } from 'src/app/models/breadcrumb-models/breadcrumb-route-model/breadcrumb-route.model';
import { TicketsService } from 'src/app/services/tickets-service/tickets.service';
import { SmsService } from 'src/app/services/sms-service/smsservice';

@Component({
  selector: 'app-turns-desks-dashboard',
  templateUrl: './turns-desks-dashboard.component.html',
  styleUrls: ['./turns-desks-dashboard.component.scss']
})
export class TurnsDesksDashboardComponent implements OnInit {

  getDesksSubscription: Subscription;
  desks;
  deskTypes;
  smsList;
  ticketList;
  filterKey;
  filterOpts;
  noItemsConfig;
  viewDisposition = 'grid';
  refreshDesksSubscription: Subscription;
  searchDesksSubscription: Subscription;
  filterDesksSubscription: Subscription;
  getDeskTypesSubscription: Subscription;
  getSmsListSubscription: Subscription;
  getTicketListSubscription: Subscription;
  toggleDesksDispositionSubscription: Subscription;

  constructor(private desksTurnsService: DesksTurnsService,
    private smsService: SmsService,
    private ticketsService: TicketsService,
    private snackbarService: SnackBarService,
    private cd: ChangeDetectorRef,
    private headerBreadcrumbService: HeaderBreadcrumbService) {
      this.noItemsConfig = this.setNoItemsConfig();
  }

  ngOnInit() {
    this.setBreadcrumb();
    this.getDeskTypes();
    this.getDesks();
    this.getSmsList();
    this.getTicketList();
    this.refreshDesksSubscription = this.desksTurnsService.refreshDesksListen().subscribe(
      (res) => {
        this.getDesks();
      }
    );
    this.filterDesksSubscription = this.desksTurnsService.filterDesksListen().subscribe(
      (res) => {
        this.filterOpts = res;
        this.cd.detectChanges();
      }
    );
    this.searchDesksSubscription = this.desksTurnsService.searchDesksListen().subscribe(
      (res) => {
        this.filterKey = res;
      }
    );
    this.toggleDesksDispositionSubscription = this.desksTurnsService.toggleDesksDispositionListen().subscribe(
      (res) => {
        this.viewDisposition = res;
      }
    );
  }

  private getDeskTypes() {
    this.getDeskTypesSubscription = this.desksTurnsService.getDeskTypes().subscribe(
      (res) => {
        this.deskTypes = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getDesks() {
    this.getDesksSubscription = this.desksTurnsService.getDesks().subscribe(
      (res) => {
        this.desks = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getSmsList() {
    this.getSmsListSubscription = this.smsService.getSmsList().subscribe(
      (res) => {
        this.smsList = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private getTicketList() {
    this.getTicketListSubscription = this.ticketsService.getTicketList().subscribe(
      (res) => {
        this.ticketList = res;
      },
      (error) => {
        this.snackbarService.open(error['error']['message'], 'error');
      }
    );
  }

  private setBreadcrumb() {
    this.headerBreadcrumbService.setRoutes(new Breadcrumb('fas fa-desktop', 'turns-page.desks', '/turns', [new BRoute('turns-page.turns', '/turns'), new BRoute('turns-page.desks')]));
  }

  private setNoItemsConfig() {
    return {
      description: 'turns-page.desks not found',
      action: '',
      lottieConfig: {
        path: 'assets/lottie-animations/empty-list.json',
        renderer: 'canvas',
        autoplay: true,
        loop: true
      }
    };
  }

  ngDestroy() {
    if (this.refreshDesksSubscription) { this.refreshDesksSubscription.unsubscribe(); }
    if (this.getDesksSubscription) { this.getDesksSubscription.unsubscribe(); }
    if (this.getSmsListSubscription) { this.getSmsListSubscription.unsubscribe(); }
    if (this.getTicketListSubscription) { this.getTicketListSubscription.unsubscribe(); }
    if (this.searchDesksSubscription) { this.searchDesksSubscription.unsubscribe(); }
    if (this.filterDesksSubscription) { this.filterDesksSubscription.unsubscribe(); }
  }
}
